<script setup lang="ts">
const auth = useAuthStore()

useEventListener('keydown', (e) => (e.key === 'F10' ? auth.toggleUser() : undefined))

const isLoading = ref(true)
const retry = async () => {
  isLoading.value = true
  await auth.checkAuth()
  setTimeout(() => {
    isLoading.value = false
  }, 1000)
}

onMounted(async () => retry())
</script>

<template>
  <template v-if="auth.isAuthenticated">
    <RouterView />
  </template>
  <Loading v-else :isLoading="isLoading" @retry="retry" />

  <PersonalSetupModal v-model:open="auth.isFirstLogin" />
</template>
